import * as Yup from 'yup';

export const validationSchema = Yup.object({
  name: Yup.string()
    .matches(
      /^[^<>:;,?"*|/]+$/,
      'Invalid characters. Avoid < > : ; , ? " * | /',
    )
    .required('Organization name is required'),
  domain: Yup.string().required('Domain is required'),
});